import React from "react";
import {EuiFlexGroup, EuiLoadingContent} from "@elastic/eui";

export default ({lines = 5}) => (
    <EuiFlexGroup direction='column'>
        <EuiLoadingContent lines={lines}/>
    </EuiFlexGroup>
)